import type {SessionSnapshot} from './domain/timerSnapshot'

export interface SessionViewState {
  session: SessionSnapshot | null
  status: 'Standalone' | 'Hosting' | 'View only' | 'Recovering' | 'Legacy'
  syncStatus: 'Synced' | 'Pending' | 'Unsynced'
  serverNowMs: number
  availableAtMs: number | null
  resumeAvailable: boolean
  error: string | null
  busy: boolean
}

export const DEFAULT_SESSION_VIEW: SessionViewState = {
  session: null, status: 'Standalone', syncStatus: 'Synced', serverNowMs: 0,
  availableAtMs: null, resumeAvailable: false, error: null, busy: false,
}
